// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".colors .ui-pagination__wrap .ui-pagination .ui-pagination-arrow-left,\n.colors .ui-pagination__wrap .ui-pagination .ui-pagination-arrow-right {\n  color: #4C1D95;\n  background: #ede9fe;\n}\n.colors .ui-pagination__wrap .ui-pagination .disabled {\n  color: #c4b5fd;\n  background: #ede9fe;\n}\n", ""]);
// Exports
module.exports = exports;
